import Box from '@amzn/awsui-components-core/box';
import Button from '@amzn/awsui-components-core/button';
import SpaceBetween from '@amzn/awsui-components-core/space-between';
import React from 'react';

interface Props {
  readonly selectedMembers: number;
  readonly selectedNotInView: number;
  readonly okDisabled: boolean;
  readonly onCancel: () => void;
  readonly onConfirm: () => void;
  readonly testId?: string;
}

export const MemberSubsetFooter: React.FC<Props> = ({ selectedMembers, selectedNotInView, okDisabled, onCancel, onConfirm, testId }) => {
  // Nothing picked means unrestricted to the API, which "All members" would misstate as everything selected.
  const unrestricted = selectedMembers === 0;
  return (
    <Box float="right">
      <SpaceBetween direction="horizontal" size="xs">
        <Box color="text-body-secondary" fontSize="body-s" padding={{ top: 'xxs' }}>
          {unrestricted ? 'None selected' : `${selectedMembers} selected`}
          {selectedNotInView > 0 ? ` · ${selectedNotInView} not in this view` : ''}
        </Box>
        <Button variant="link" onClick={onCancel} data-testid={testId ? `${testId}-cancel` : undefined}>
          Cancel
        </Button>
        <Button variant="primary" disabled={okDisabled} onClick={onConfirm} data-testid={testId ? `${testId}-ok` : undefined}>
          {unrestricted ? 'OK' : `OK (${selectedMembers})`}
        </Button>
      </SpaceBetween>
    </Box>
  );
};
